define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var DomainModel = /** @class */ (function () {
        function DomainModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.AllowMultiple = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, DomainModel.Mapping, self);
            }
        }
        DomainModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new DomainModel(options.data);
            }
        };
        return DomainModel;
    }());
    return DomainModel;
});
//# sourceMappingURL=DomainModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/DomainModel.js
// module id = 235
// module chunks = 2